


















































































import CCategoryPicker from '~/components/shared/configurable/category/picker/CCategoryPicker.vue'
import { CategoryId, TreeLevelCategory } from '~/models/category/types'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import CCategorySearch from '~/components/shared/configurable/category/CCategorySearch.vue'
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
  useRoute,
  useRouter
} from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useNamespacedStore } from '~/compositions/store'
import { FieldChange } from '~/models/form/types'
import { useDeps } from '~/compositions/dependency-container'
import CategoryTreeLevelService from '~/services/category/CategoryTreeLevelService'
import { resolveCategory } from '~/utils/category'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { handleError } from '~/utils/http'
import { useLogger } from '~/compositions/logger'
import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import { ciThreeDots } from '~/icons/source/regular/message-dots'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { Ref } from '@vue/composition-api'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  components: {
    CFormError,
    CCategoryPicker,
    CCategorySearch
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const loaded = ref(false)
    const selectedCategory = ref<number | null>(null)
    const categories = ref<TreeLevelCategory[]>([])

    const { state } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)
    const inEditMode = computed(() => state.editMode)

    const rootCategoryId = computed(() => specs.value?.root_category)

    function onValue(v: Ref) {
      let valueToSet
      if (Array.isArray(v.value)) {
        valueToSet = v.value.length ? v.value[0] : null
      } else {
        valueToSet = v.value || null
      }

      if (
        (categories.value.length === 0 &&
          rootCategoryId.value !== valueToSet) ||
        categories.value.some(c => c.id === valueToSet)
      ) {
        selectedCategory.value = valueToSet
      } else {
        selectedCategory.value = null
      }
    }

    const { valuesChanged, error } = useClassifiedForm(props, {
      onValue
    })

    const route = useRoute()
    const router = useRouter()

    const logger = useLogger()
    const snackbar = useSnackbar()
    const { t } = useI18n()

    const [categoryTreeLevelService] = useDeps(CategoryTreeLevelService)

    const categoryId = computed(() => state.categoryId)
    const schemaExtras = computed(() => state.extras)

    const handleSelectCategoryChange = (categoryId: number) => {
      const category = categories.value.find(c => c.id === categoryId)
      if (category) {
        if (category.movedToCategoryUrl) {
          window.location.href = category.movedToCategoryUrl
          return
        }

        handleCategoryChange(category)
      }
    }
    const handleCategoryChange = (category: TreeLevelCategory) => {
      if (category.movedToCategoryUrl) {
        return
      }

      const categoryId = category.id
      selectedCategory.value = categoryId
      if (!inEditMode.value && categoryId !== -1) {
        window.history.pushState(
          {},
          '',
          router.resolve({
            params: { categoryId: categoryId.toString() },
            query: route.value.query
          }).href
        )
      }
      emitChanges()
    }

    const categoriesAsOptions = computed(() =>
      categories.value.map(c => {
        return { text: c.humanName, value: c.id }
      })
    )
    const fetchCategories = async () => {
      try {
        const categoryTree = await categoryTreeLevelService.getCategoryTreeLevels(
          rootCategoryId.value,
          rootCategoryId.value,
          {
            rootUrlParam: true
          }
        )

        const { levels } = categoryTree

        categories.value = levels?.length ? levels[levels.length - 1] : []
        loaded.value = true
      } catch (e) {
        handleError(e, snackbar, logger, t)
      }
    }

    onMounted(async () => {
      await fetchCategories()
    })

    const emitChanges = () => {
      const categoryRelatedChanges: FieldChange[] = [
        {
          name: name.value,
          value: selectedCategory.value
        }
      ]

      valuesChanged(categoryRelatedChanges)
    }

    const getIconForCategory = (categoryId: number) => {
      return resolveCategory(categoriesIconsMappings, [categoryId])
    }

    const splitCategoryName = (categoryName: string) => {
      const splitArray = categoryName.split('/')

      if (splitArray.length) {
        return splitArray.map((text, index) => {
          if (index + 1 < splitArray.length) {
            return text + '/'
          }
          return text
        })
      }

      return splitArray
    }

    const { isMobile } = useUserAgent()

    return {
      categories,
      loaded,
      selectedCategory,
      rootCategoryId,
      categoryId,
      handleCategoryChange,
      handleSelectCategoryChange,
      error,
      schemaExtras,
      inEditMode,
      getIconForCategory,
      splitCategoryName,
      ciThreeDots,
      categoriesAsOptions,
      CategoryId,
      isMobile
    }
  }
})
